//copied from v1
import React from "react";
import { Box } from "@indeed/ifl-components";

export const Ellipse = ({ sx, ...props }) => (
  <Box
    as="svg"
    width="3"
    height="3"
    viewBox="0 0 3 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    sx={sx}
    aria-hidden={true}
    {...props}
  >
    <Box as="circle" cx="1.5" cy="1.5" r="1.5" fill="currentColor" />
  </Box>
);
